<div class="flat-card">
  <ng-content></ng-content>
</div>
